module.exports = __webpack_public_path__ + "11b7f30a65752eba10704a93457ce8e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/plats-du-chef/02.jpg
// module id = 3Opn
// module chunks = 0